var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"myButton",class:{
    'btn-disable': _vm.type !== 'link' ? _vm.disable : false,
    'btn-basic': _vm.type === 'active',
    'btn-basic-secondary': _vm.type === 'passive',
    'fake-link': _vm.type === 'link',
    'disable-fake-link': _vm.type === 'link' ? _vm.disable : false,
    small: _vm.size === 'small'
  },attrs:{"disabled":_vm.disable,"data-cy":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[(!_vm.disable || _vm.type === 'link')?_vm._t("default",[_vm._v(_vm._s(_vm.$tc(_vm.$translate.Save)))]):_vm._e(),(_vm.disable && _vm.type !== 'link')?_c('b-spinner',{attrs:{"small":""}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }